<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('pricing_models.title')"/>
        <pricing-model-list
            class="my-2"
            :results="results"
            @add="addNew"
        />
        <base-modal v-if="editMode" hide-header hide-footer @close="showList">
            <pricing-model-editor
              :pricing-model="pricingModel"
              @close="showList"
              @close-and-update="closeAndUpdate"
            />
        </base-modal>
        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import PricingModelList from "./PricingModelList";
import PricingModelEditor from "./PricingModelEditor";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'PricingModels',
    components: {BaseModal, Navbar, PricingModelEditor, PricingModelList},
    mixins: [restApi],
    data: function () {
        return {
            results: [],
            pricingModel: null,
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
         this.fetchPricingModels()
    },
    methods: {
        fetchPricingModels: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.pricingModeUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        addNew: function () {
            this.pricingModel = {id: null, unit1: null, unit2: null}
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchPricingModels()
            this.showList()
        }

    }
}
</script>
